module.exports = __webpack_public_path__ + "img/multiplier3_normal.93f44df6.png";